/* eslint-disable no-console */
import { useCallback, useEffect, useState } from "react";
import { client } from "../../../Utils/axiosClient";

const useDriverOptions = () => {
  const [drivers, setDrivers] = useState([]);

  const getDrivers = useCallback(async () => {
    try {
      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/drivers/filter-drivers`,
      );

      if (response.status === 200) {
        const temp = response?.data?.result
          ?.map((r) => ({
            id: r.id,
            value: `${r?.firstName || ""} ${r?.lastName || ""}`,
          }))
          ?.sort((a, b) => a?.value?.localeCompare(b?.value));

        setDrivers(temp);
      }
    } catch (error) {
      console.log(error);
      setDrivers([]);
    }
  }, []);

  useEffect(() => {
    getDrivers();
  }, [getDrivers]);

  return drivers;
};

export default useDriverOptions;
